import { renderElement } from "../../utils/use-render.js";
import { forwardRef } from "react";
//#region src/ui/time/group.tsx
/**
* Container for composed time displays. Renders a `<span>` element.
*
* @example
*   ```tsx
*   <Time.Group>
*     <Time.Value type="current" />
*     <Time.Separator />
*     <Time.Value type="duration" />
*   </Time.Group>;
*   ```;
*/
const Group = forwardRef(function Group(componentProps, forwardedRef) {
	const { render, className, style, children, ...elementProps } = componentProps;
	return renderElement("span", {
		render,
		className,
		style
	}, {
		state: {},
		ref: [forwardedRef],
		props: [{ children }, elementProps]
	});
});
//#endregion
export { Group };

//# sourceMappingURL=group.js.map